import styled from 'styled-components';

import { max, min } from '../../utils/breakpoints';

const RadioWrapper = styled.div`
  width: 100%;
  text-align: left;
  border: 2px solid ${(props) => props.theme.colors.light};
  border-radius: 4px;
  margin-bottom: 24px;
  padding: 20px 15px;

  ${max.sm} {
    padding: 10px 8px;
    margin-bottom: 12px;
  }

  &.selected {
    border-color: ${(props) => props.theme.colors.primary};

    .form-check {
      background: url(${(props) => props.theme.forms.formControl.radio.checked.backgroundImage}) no-repeat 2% center;
    }
  }

  .form-check {
    padding-left: 0;
    padding-top: 4px;
    padding-bottom: 4px;
    background: url(${(props) => props.theme.forms.formControl.radio.unchecked.backgroundImage}) no-repeat 2% center;

    input {
      display: none;
    }

    label {
      padding-left: 45px;
      cursor: pointer;
      font-size: 14px;

      ${min.sm} {
        font-size: 16px;
      }
    }
  }

  .form-group {
    margin-top: 10px;
    padding-left: 45px;
    padding-right: 30px;
  }
`;

export default RadioWrapper;
